import RequestGeneralInfo from './RequestGeneralInfo.vue';
import RequestContactInfo from './RequestContactInfo.vue';
import RequestPostalAddressInfo from './RequestPostalAddressInfo.vue';
import RequestEducationalServiceInfo from './RequestEducationalServiceInfo.vue';
import RequestAdditionalInfo from './RequestAdditionalInfo.vue';
import AssistantService from './AssistantService.vue';

export {
  RequestGeneralInfo,
  RequestContactInfo,
  RequestPostalAddressInfo,
  RequestEducationalServiceInfo,
  RequestAdditionalInfo,
  AssistantService
};
